import { MongooseModel } from '../models';

export function groupByKey<T>(items: T[], key: string) {
  return items?.reduce(function (r, a) {
    r[a[key]] = r[a[key]] || [];
    r[a[key]].push(a);
    return r;
  }, Object.create(null));
}
